
/**音频信息 */
import Cookies from 'js-cookie'
const state = {
    warnswitchsta:Cookies.get('vedioWarnSwitch') ,
    autoplay:false,
    warnlevel:"0",
    warnplayend:false,
    switchAllStatus: Cookies.get('vedioAllSwitch') 
}
  
const mutations = {
    TOGGLE_SWITCH: (state,warnlevel) => {
        if(warnlevel) state.warnlevel = warnlevel
        state.warnswitchsta = !state.warnswitchsta
        if (state.warnswitchsta) {
            Cookies.set('vedioWarnSwitch', "1")
        } else {
            Cookies.set('vedioWarnSwitch', "0")
        }
    }, 
    SET_SWITCH: (state, warnswitchsta) => {
        state.warnswitchsta = warnswitchsta
        Cookies.set('vedioWarnSwitch', warnswitchsta)
    },
    SET_AUTOPLAY: (state, autoplay) => {
        state.autoplay = autoplay
    },
    SET_WarnLevel: (state, warnlevel) => {
        state.warnlevel = warnlevel
    },
    SET_WarnPlayEnd: (state, warnplayend) => {
        state.warnplayend = warnplayend
        Cookies.set('vedioWarnEnd', warnplayend)
    },
    SET_SWITCHALL: (state, switchAllStatus) => {
        state.switchAllStatus = switchAllStatus
        Cookies.set('vedioAllSwitch', switchAllStatus)
    },
  }
  
  const actions = {
    toggleSwitchStatus({ commit }, warnlevel) {
        commit('TOGGLE_SWITCH', warnlevel)
    },
    setSwitchStatus({ commit }, warnswitchsta) {
      commit('SET_SWITCH', warnswitchsta)
    },
    setSwitchOn({ commit }, warnlevel) {
        commit('SET_WarnLevel', warnlevel)
        commit('SET_SWITCH', "1")
    },
    setSwitchOff({ commit }) {
        commit('SET_SWITCH', "0")
    },
    setSutoPlay({ commit }, autoplay) {
        commit('SET_AUTOPLAY', autoplay)
    },
    setWarnLevel({ commit }, warnlevel) {
        commit('SET_WarnLevel', warnlevel)
    },  
    setWarnPlayEnd({ commit }, warnplayend) {
        commit('SET_WarnPlayEnd', warnplayend)
    },
    setSwitchAllStatus({ commit }, switchAllStatus) {
        commit('SET_SWITCHALL', switchAllStatus)
    },
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  